var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWithoutText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 85",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 133.514 35.671 C 141.786 41.284 140.726 56.251 128.068 69.876 C 115.62 83.278 95.381 88.885 86.143 81.58 C 78.862 75.83 83.147 66.056 77.326 66.056 C 69.965 66.056 38.713 95.598 11.044 80.737 C -5.942 71.607 -3.268 45.278 18.607 23.62 C 39.887 2.547 71.982 -6.344 88.259 4.895 C 110.044 19.942 85.616 43.217 91.75 46.328 C 96.217 48.596 115.251 23.269 133.514 35.665 L 133.514 35.671 Z M 107.937 58.5 C 113.733 58.512 119.102 54.197 119.102 50.668 C 119.102 49.395 118.306 47.62 115.375 47.62 C 108.628 47.62 96.667 54.761 85.474 54.761 C 70.786 54.761 75.275 26.91 57.595 26.91 C 43.703 26.91 30.571 40.073 30.571 49.426 C 30.571 55.774 35.822 58.518 41.634 58.518 L 107.937 58.506 L 107.937 58.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/logo-without-text.01e3db53.svg";
export { ForwardRef as ReactComponent };